import { styled } from "@woba/ds-web";

export const DropdownItemsWrapper = styled("div", {
  maxHeight: 280,
  overflow: "auto",
});
